<template>
  <div>
    <el-dialog
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="visible"
      width="600px"
      top="30px"
    >
      <template slot="title">
        <el-descriptions title="百度地图坐标取点" :column="1">
          <template slot="extra">
            <el-button @click="handleCancel" :size="$xUISize"> 取消 </el-button>
            <el-button @click="handleSave" type="primary" :size="$xUISize">
              确定
            </el-button>
          </template>
        </el-descriptions>
      </template>
      <div>
        <div style="margin-bottom: 10px">
          <el-input
            clearable
            v-model="searchAddress"
            @change="searchByAddress"
            placeholder="请输入商圈、小区名搜索"
          >
            <el-button
              slot="append"
              :disabled="!searchAddress"
              @click="searchByAddress"
            >
              搜索
            </el-button>
          </el-input>
        </div>
        <el-descriptions :column="1" v-if="longitude && latitude">
          <el-descriptions-item label="所在省市区">
            {{ [province, city, area].filter((item) => !!item).join("-") }}
          </el-descriptions-item>
          <el-descriptions-item label="坐标经纬度">
            {{ longitude || "" }}，{{ latitude || "" }}
          </el-descriptions-item>
        </el-descriptions>
        <template v-if="loadSuccess">
          <div
            id="container"
            ref="baiduMapContainer"
            class="baiduMapContainer"
            v-show="longitude && latitude"
            v-loading="searchLoading"
          ></div>
          <div v-if="!longitude || !latitude">
            {{ searchError || "请输入商圈、小区名搜索" }}
          </div>
        </template>
        <el-empty
          v-else-if="!loading"
          :description="loadErrorMsg || '地图组件加载失败'"
          :image-size="100"
        >
          <el-button v-if="loadErrorMsg" @click="refreshMap" :size="$xUISize">
            重新加载
          </el-button>
        </el-empty>
        <div style="margin-top: 20px">
          <template v-if="locationInfo && locationInfo.surroundingPois">
            <div style="display: flex; flex-wrap: wrap">
              <div
                :key="'pos-' + index"
                style="margin-right: 10px; margin-top: 10px"
                v-for="(pos, index) in locationInfo.surroundingPois"
              >
                <el-tag type="info" @click="handleSelectPosClick(pos)">
                  {{ pos.title }}
                </el-tag>
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>
    <el-link :underline="false" style="color: #3399ff" @click="handleEditClick">
      在地图中标记位置
    </el-link>
  </div>
</template>

<style lang="less" scoped>
.baiduMapContainer {
  width: 100%;
  height: 250px;
}
/deep/ .el-input__inner {
  color: #919191;
}
</style>

<script>
export default {
  data() {
    return {
      loading: false,
      loadPromise: null,
      loadErrorMsg: null,
      loadSuccess: false,
      locationPos: null,
      locationInfo: null,
      searchLoading: false,
      searchError: "",
      searchAddress: "",
      longitude: "",
      latitude: "",
      province: "",
      city: "",
      area: "",
      visible: false,
      marker: null,
      map: null
    };
  },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    address: {
      type: String
    },
    defaultZoom: {
      type: Number,
      default: 20
    }
  },
  watch: {
    address() {
      this.searchAddress = this.address;
    }
  },
  computed: {
    locationAddress() {
      if (!this.locationInfo || !this.locationInfo.addressComponents) {
        return;
      }
      let poiTitle = '';
      let locaAddress = this.locationInfo.address;
      if (this.locationPos) {
        locaAddress = this.locationPos.address;
        poiTitle = this.locationPos.title;
      }
      return [locaAddress, poiTitle].filter(item => !!item).join('')
    }
  },
  methods: {
    handleSelectPosClick(pos) {
      this.searchAddress = "";
      this.locationPos = pos;
      this.longitude = pos.point.lng;
      this.latitude = pos.point.lat;
      this.refreshMap();
    },
    loadBmpgl() {
      if (this.loadPromise) {
        return this.loadPromise;
      }
      this.loading = true;
      this.loadSuccess = false;
      this.loadPromise = new Promise((resolve, reject) => {
        try {
          window.baiduMapInitReady = function () {
            // eslint-disable-next-line
            resolve && resolve(BMapGL)
          }
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = `//api.map.baidu.com/api?v=1.0&type=webgl&ak=${this.getConfig('baiduMapAk')}&callback=baiduMapInitReady`
          script.onerror = (err) => {
            reject && reject(err)
          }
          document.head.appendChild(script)
        } catch (error) {
          reject && reject(error)
        }
      }).then((resp) => {
        this.loading = false;
        this.loadSuccess = true;
        return resp;
      }).catch((err) => {
        this.loading = false;
        this.loadErrorMsg = err && err.message || "加载百度地图SDK失败";
        this.loadPromise = null;
      })
      return this.loadPromise;
    },
    handleEditClick() {
      this.visible = true;
      this.longitude = this.values[0];
      this.latitude = this.values[1];
      this.province = this.values[2];
      this.city = this.values[3];
      this.area = this.values[4];
      this.$nextTick(() => {
        if (!this.latitude || !this.longitude) {
          this.searchByAddress();
        } else {
          this.refreshMap();
        }
      });
    },
    handleSave() {
      this.visible = false;
      this.$emit("save", [this.longitude, this.latitude, this.province, this.city, this.area]);
    },
    handleCancel() {
      this.visible = false;
    },
    //地址解析成坐标点
    searchByAddress() {
      this.loadBmpgl().then(() => {
        if (!this.searchByAddress) {
          return;
        }
        let geocoder = new BMapGL.Geocoder()
        this.searchLoading = true;
        this.searchError = "";
        this.locationInfo = null;
        geocoder.getPoint(this.searchAddress, (point) => {
          this.searchLoading = false;
          if (point) {
            this.longitude = point.lng;
            this.latitude = point.lat;
            this.refreshMap();
          } else {
            this.searchError = `地图中找不到${this.searchAddress}的坐标`
          }
        });
      });
    },
    fetchAddress(BMapGL) {
      // 用所定位的经纬度查找所在地省市街道等信息
      let geocoder = new BMapGL.Geocoder()
      let point = new BMapGL.Point(this.longitude, this.latitude);
      geocoder.getLocation(point, (rs) => {
        this.locationInfo = rs;
        this.province = this.locationInfo.addressComponents.province;
        this.city = this.locationInfo.addressComponents.city;
        this.area = this.locationInfo.addressComponents.district;
        if (this.locationPos) {
          let flag = false;
          if (this.locationInfo.surroundingPois && this.locationInfo.surroundingPois.length > 0) {
            this.locationInfo.surroundingPois.forEach(item => {
              if (item.uid == this.locationPos.uid) {
                this.locationPos = item;
                flag = true;
              }
            });
          }
          if (!flag) {
            this.locationPos = null;
          }
        }
      })
    },
    refreshMap() {
      if (!this.longitude || !this.latitude) {
        return;
      }
      this.loadBmpgl().then((BMapGL) => {
        if (!this.$refs.baiduMapContainer) {
          setTimeout(() => { this.refreshMap() }, 300);
          return;
        }
        this.fetchAddress(BMapGL);
        // 创建地图实例
        this.map = new BMapGL.Map("container");
        // 开启鼠标滚轮缩放
        this.map.enableScrollWheelZoom(true);
        // 创建点坐标 axios => res 获取的初始化定位坐标
        let point = new BMapGL.Point(this.longitude, this.latitude);
        // 初始化地图，设置中心点坐标和地图级别
        this.map.centerAndZoom(point, this.defaultZoom);
        // 新建标注
        this.marker = new BMapGL.Marker(point);
        // 添加标注到地图
        this.map.addOverlay(this.marker);
        // 标注拖曳事件
        this.marker.enableDragging();
        // 监听位置变化
        this.marker.addEventListener("dragend", (e) => {
          this.latitude = e.latLng.lat;
          this.longitude = e.latLng.lng;
          this.map.centerAndZoom(new BMapGL.Point(this.longitude, this.latitude));
          this.fetchAddress(BMapGL);
        });
      });
    },
  },
  mounted() {
    this.searchAddress = this.address || this.getConfig('baiduMapDefaultAddress');
    this.searchByAddress();
  }
};
</script>